import { createFileRoute } from '@tanstack/react-router';
import { CampaignsDevRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/dev/db/campaigns/')({
  component: CampaignsDevRoute,
});
